import { Skeleton } from "@kyan/ui";
import type { ReactNode } from "react";

export interface LoadOrRenderProps {
  children?: ReactNode;
  isLoading?: boolean;
  className?: string;
}

export const LoadOrRender: React.FC<LoadOrRenderProps> = ({
  className,
  children,
  isLoading,
}) => {
  return isLoading ? <Skeleton className={className} /> : <>{children}</>;
};
